import { useExcursionFiltersStore } from '@/entities/filter/store/excursion';
import { useFormatTypes } from '../useFormatTypes';
import type ru from '../../i18n/ru.json';
import { useComponentI18n } from '@/shared/composables/useComponentI18n';

type TSchema = typeof ru;

export function useExcursionFilterFormatTitle(messages: TSchema) {
  const { t } = useComponentI18n({ ru: messages });

  const filterStore = useExcursionFiltersStore();

  const { FORMAT_AVAILABLE, typesAvailable } = useFormatTypes(messages);

  function getDefaultTitle() {
    return t('format.title');
  }

  function setCurrentEndOfLabel(label: string) {
    if (label === FORMAT_AVAILABLE.INDIVIDUAL.label) {
      return t('format.individual.plural');
    }

    if (label === FORMAT_AVAILABLE.GROUP.label) {
      return t('format.group.plural');
    }

    return t('format.minigroup.plural');
  }

  const title = computed(() => {
    const selected = filterStore.searchState.type;

    if (!selected.length) {
      return getDefaultTitle();
    }

    return typesAvailable
      .reduce((acc, item) => {
        if (selected.includes(item.value)) {
          acc.push(acc.length ? setCurrentEndOfLabel(item.label).toLowerCase() : setCurrentEndOfLabel(item.label));
        }

        return acc;
      }, [] as string[])
      .join(', ');
  });

  const itemsCount = computed(() => filterStore.searchState.type.length);

  const isActive = computed(() => title.value !== getDefaultTitle());

  return {
    title,
    itemsCount,
    FORMAT_AVAILABLE,
    typesAvailable,
    isActive,
  };
}
